import React from 'react';

const CircularSpinner = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg viewBox="22 22 44 44" {...props}>
      <rect
        width="44"
        height="44"
        x="22"
        y="22"
        fill="url(#circular-spinner-gradient)"
        mask="url(#circular-spinner-mask)"
      />
      <defs>
        <linearGradient id="circular-spinner-gradient" x1="0%" y1="100%" x2="80%" y2="0%">
          <stop offset="4.57%" stopColor="#E71609" />
          <stop offset="102.26%" stopColor="#D99E00" />
        </linearGradient>
        <mask id="circular-spinner-mask">
          <rect x="22" y="22" width="44" height="44" fill="#000" />
          <circle
            cx="44"
            cy="44"
            r="20.2"
            fill="none"
            stroke="#FFF"
            strokeWidth="3.6"
            strokeDasharray="80px, 200px"
          >
            <animateTransform
              attributeName="transform"
              attributeType="XML"
              type="rotate"
              from="0 44 44"
              to="360 44 44"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </circle>
        </mask>
      </defs>
    </svg>
  );
};

export default CircularSpinner;
